// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (max-width:1023px){#cp-search-nav{height:64px!important;border:none}}", ""]);
// Exports
module.exports = exports;
